export default __webpack_public_path__ + "static/media/BreadCrumbArrow.5cd630e6.svg";